import {Component} from "@angular/core";

@Component({
  selector: 'administration-component',
  templateUrl: './administration.component.html',
  host: {'class': 'page'}
})
export class AdministrationPageComponent {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/administration/administration.component.ts